import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  saveSignBothData,
  changeEaState,
  searchSignatureData,
  saveEaJsonData,
} from '@store/actions/eaAction';

import EaHeader from '@components/ea/EaHeader';
import EaBottom from '@components/ea/EaBottom';

import SatModal from '@components/common/satUI/SatModal';
import LifePlannerSignPopup from '@components/common/biz/LifePlannerSignPopup';

const LifePlannerSign = props => {
  const {
    applicationNo,
    onClickNext,
    empName,
    empNumber,
    isPracticeMode = false,
    contractSign,
  } = props;
  const dispatch = useDispatch();
  const { channelInfo } = useSelector(state => state.userReducer);
  const { planMainInfo, completePage, signData } = useSelector(
    state => state.eaReducer,
  );

  const reportId = 'lpSignInfo';
  const { isLP, isDM } = $utils.getChannelCheckInfo(channelInfo.cdVal);
  const [isShowSighPopup, setIsShowSighPopup] = useState(''); // 서명팝업 노출 여부

  // 전자 서명 조회
  const handleSearchSignData = () => {
    dispatch(
      searchSignatureData({
        signGubun: 'E',
        reportId,
        empNumber,
        signId: 'signData',
        nameId: 'nameData',
      }),
    );
  };

  const handleOnSave = (signNameData, signatureData) => {
    // 보험설계사 서명 저장
    setIsShowSighPopup(false);

    if (!isPracticeMode)
      dispatch(
        saveSignBothData({
          applicationNo: applicationNo,
          signNameData: signNameData,
          signatureData: signatureData,
          signGubun: 'E',
          reportId,
          empNumber,
          callback: callbackSuccess,
        }),
      );
    else {
      dispatch(
        changeEaState({
          type: 'signData',
          data: {
            ...signData,
            lpSignInfo: { signData: signatureData, nameData: signNameData }, // 보험설계사 서명
          },
        }),
      );
      callbackSuccess(true);
    }
  };

  const callbackSuccess = type => {
    if (type) {
      const completePages = [...completePage, 9];
      dispatch(
        changeEaState({
          type: 'completePage',
          data: [...new Set(completePages)],
        }),
      );
      !isPracticeMode &&
        setTimeout(() => {
          dispatch(saveEaJsonData({ applicationNo: applicationNo }));
        }, 200);

      onClickNext();
      setIsShowSighPopup(false);
    }
  };

  return (
    <React.Fragment>
      <EaHeader
        title={
          isLP && !channelInfo.lpDeptYn
            ? '3. 청약관련 문서 - 라이프파트너 서명'
            : '3. 청약관련 문서 - 보험설계사 서명'
        }
        isFirstPage={false}
        isPracticeMode={isPracticeMode}
      />
      <div className="con-wrap bg-gray">
        <div className="app-wrap">
          <div className="app-box">
            <h2 className="tit-con mgt-0">
              {isLP && !channelInfo.lpDeptYn
                ? '라이프파트너 서명 일괄적용 하기'
                : '보험설계사 서명 일괄적용 하기'}
            </h2>
            <p className="text-con">
              {isLP && !channelInfo.lpDeptYn
                ? '라이프파트너 서명이 필요한 아래 청약 문서에 서명을 등록해 주세요.'
                : '보험설계사 서명이 필요한 아래 청약 문서에 서명을 등록해 주세요.'}
            </p>
            <ul className="dot-type type-l mgt-16">
              <li>
                {isLP && !channelInfo.lpDeptYn
                  ? '상품설명서 (상품설명사실 확인을 위한 라이프파트너 확인 내용 포함)'
                  : '상품설명서 (상품설명사실 확인을 위한 보험설계사 확인 내용 포함)'}
              </li>
              <li>보험계약사항 비교안내문</li>
              <li>간편심사 상품에 대한 계약자 확인서 (특정 상품에 한함)</li>
              <li>
                해약환급금 미지급형/일부지급형 계약자 확인서 (특정 상품에 한함)
              </li>
              {contractSign?.newContract?.list2?.replaceAll('-', '') >
                20220331 && (
                <li>외화보험상품 주요내용 확인서 (특정 상품에 한함)</li>
              )}
              <li>VIP고객확인서 (특정 경우에 한함)</li>
              <li>친권자 확인서 (특정 경우에 한함)</li>
              <li>종신전환 신청서 (특정 경우에 한함)</li>
              <li>대출 납입 일시중지 후 신계약 확인서 (특정 경우에 한함)</li>

              {/* 완전 판매 확인서는 DM 채널만 노출 */}
              {isDM && <li>완전 판매 확인서</li>}
            </ul>
          </div>
        </div>
      </div>
      <SatModal
        visible={isShowSighPopup}
        type="info"
        wide
        setVisible={() => {
          setIsShowSighPopup(false);
        }}
        isNotification={true}
      >
        <LifePlannerSignPopup
          searchSignData={handleSearchSignData}
          ownerName={planMainInfo.ownerPrspInfo.name}
          applicationNo={applicationNo}
          onClose={() => setIsShowSighPopup(false)}
          signData={signData.lpSignInfo}
          complete={completePage.includes(9)}
          empName={empName}
          onSave={handleOnSave}
          userType={channelInfo.cmnCdNm}
          lpDeptYn={channelInfo.lpDeptYn}
        />
      </SatModal>
      <EaBottom
        label="서명등록"
        disabled={false}
        onClick={() => setIsShowSighPopup(true)}
      />
    </React.Fragment>
  );
};

export default LifePlannerSign;
